import React from 'react';
import PricingPage from '@/components/Pages/PricingPage';

export default function Pricing() {
  return <PricingPage />;
}
